module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp1_8017.d744c7d5.png";